<template>
  <div>
    <v-btn  color="primary"
            @click.stop="dialog = true"
    >
      <v-icon class="margin-right-small">mdi-plus-circle</v-icon>
      Add user
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="500"
      persistent
    >
      <AddUserForm 
        v-if="dialog"
        :connection="connection"
        @cancel="dialog = false"
        @ok="dialog = false"
        @users-updated="$emit('users-updated', $event)"
        @failure="$emit('failure', $event)"
      ></AddUserForm>
    </v-dialog>
  </div>
</template>

<script>
import AddUserForm from "./AddUserForm";

export default {
  name:       "AddUser",
  components: { AddUserForm },
  props:      ["connection"],
  data:       () => ({
    dialog: false
  })
}
</script>

<style scoped>
</style>
